import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Outlet, Navigate } from "react-router-dom"
import { API } from './constant'

const PrivateRoute = () => {
    // const auth = { "token": false }
    const [auth, setauth] = useState(false)

    if (!localStorage.getItem("token")) {
        return <Navigate to="/login" />
    } else if (localStorage.getItem("token") === undefined) {
        return <Navigate to="/" />
    }
    return <Outlet />

}

export default PrivateRoute